import type { FC } from 'react';

import type { CommentFilterType } from '../hooks';

interface EmptyCommentsProps {
  statusFilter: CommentFilterType;
  status?: string;
}

const getEmptyCommentsText = (statusFilter: CommentFilterType, status?: string) => {
  if (status !== 'REVIEW') {
    return (
      <>
        When the contract is in Review,
        <br /> select a block to add the first comment.
      </>
    );
  }

  if (statusFilter === 'all') {
    return 'Be the first to add a comment to start the conversation.';
  }

  return `Try adjusting your filters to see more comments.`;
};

export const EmptyComments: FC<EmptyCommentsProps> = ({ statusFilter, status }) => {
  return (
    <div className="flex h-full flex-col items-center justify-center px-7 py-12 text-center">
      <div className="mb-4">
        <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
          <svg className="h-6 w-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
            />
          </svg>
        </div>
        <h3 className="mb-1 text-sm font-medium text-gray-900">
          {statusFilter === 'all' ? 'No comments yet' : `No ${statusFilter} comments`}
        </h3>
        <p className="text-xs text-gray-500">{getEmptyCommentsText(statusFilter, status)}</p>
      </div>
    </div>
  );
};
